export default "__VITE_ASSET__BzMfSlsl__"